import { Injectable } from '@angular/core';

import { RouterReducerState } from '@ngrx/router-store';
import { select, Store } from '@ngrx/store';

import { RouterStateUrl } from '@sd-portal/shared/util';

import * as actions from './shared-audit.actions';
import { State } from './shared-audit.reducer';
import { sharedAuditQuery } from './shared-audit.selectors';
import { AuditScreen } from '../audit-screen.enum';

@Injectable()
export class SharedAuditFacade {
  showAuditDrawer$ = this.store.pipe(select(sharedAuditQuery.getShowAuditDrawer));
  enableAudit$ = this.store.pipe(select(sharedAuditQuery.getEnableAudit));
  auditScreen$ = this.store.pipe(select(sharedAuditQuery.getAuditScreen));
  auditScreens$ = this.store.pipe(select(sharedAuditQuery.getAuditScreens));
  selectedAuditScreen$ = this.store.pipe(select(sharedAuditQuery.getSelectedAuditScreen));

  constructor(
    private readonly store: Store<{
      router: RouterReducerState<RouterStateUrl>;
      sharedAudit: State;
    }>
  ) {}

  selectAuditScreen(selectedAuditScreen: AuditScreen) {
    this.store.dispatch(actions.SelectAuditScreen({ selectedAuditScreen }));
  }

  showAuditDrawer() {
    this.store.dispatch(actions.ShowAuditDrawer());
  }

  hideAuditDrawer() {
    this.store.dispatch(actions.HideAuditDrawer());
  }
}
